import { EPICS_PATH_PREFIX } from 'volto-epics-addon/constants';

export const EPICS_PATH_VERIFY_EMAIL = `${EPICS_PATH_PREFIX}/verify-email`;
export const EPICS_PATH_SIGNICAT_CAPTURE = `${EPICS_PATH_PREFIX}/capture`;
export const EPICS_PATH_SUOMIFI_CALLBACK = `${EPICS_PATH_PREFIX}/suomifi`;
export const EPICS_PATH_CPU_PAYMENT = `${EPICS_PATH_PREFIX}/payment`;
